import React, {Component, ReactElement} from 'react'
import {Nullable} from '../../../app/TypeHelpers'
import {createGuestPage, GuestPagePropsSet} from '../../../components/shared/hoc/createGuestPage'
import {NatExternalTransmissionForm} from './NatExternalTransmissionForm'
import {Location} from 'react-router-dom'

interface Props {
    location: Location
}

class NatGuestExternalTransmissionPage extends Component<Props & GuestPagePropsSet> {

    constructor(props: Props & GuestPagePropsSet) {
        super(props);
    }
    render(): Nullable<ReactElement> {
        return (
                <NatExternalTransmissionForm mode={'guest'} />
        )
    }
}
export default createGuestPage(NatGuestExternalTransmissionPage)
